import { CURRENT_ROLE } from "../API/url";


export const Home_PAGE_URL = CURRENT_ROLE === 'Seeker' ? "/seekerHome/":CURRENT_ROLE === 'Expert'?'/expertHome/':CURRENT_ROLE ==="CM"?'/cmHome/':CURRENT_ROLE ==="Admin"?'/adminhome/':CURRENT_ROLE ==="Emails"?'/emailHome/':null;
export const SEARCH_PAGE_URL = `${Home_PAGE_URL}search/:textparam/:isAsk`;
export const DOES_NOT_EXIST = `*`;
export const PROFILE_PAGE_URL = `${Home_PAGE_URL}profile`;
export const TRENDING_PAGE_URL = `${Home_PAGE_URL}trending`;
export const HISTORY_PAGE_URL = `${Home_PAGE_URL}history`;
export const RECOMMEND_PAGE_URL = `${Home_PAGE_URL}recommend`;
export const OPEN_QUESTIONS = `${Home_PAGE_URL}open`;
export const ANSWERED_QUESTION = `${Home_PAGE_URL}answered`;
export const FAVOURITE_QUESTION = `${Home_PAGE_URL}favourite`;
export const SAVED_TABS = `${Home_PAGE_URL}saved`
export const SHARED_BY = `${Home_PAGE_URL}sharedby`;
export const SHARED_WITH = `${Home_PAGE_URL}sharedwith`;
export const KEYTAG_DATA = `${Home_PAGE_URL}tagdata`;
export const KEYTERM_DATA = `${Home_PAGE_URL}keyterm`;
export const URL_REDIRECTION_URL = `${Home_PAGE_URL}:urlKey/:urlValue`;
export const EXPERT_STAT_URL = `${Home_PAGE_URL}mystat`;
export const KNOWLEDGE_ENTRY = `/${Home_PAGE_URL}createqapair`;
export const EXPERT_EDITOR_URL = `${Home_PAGE_URL}editor`;
export const GRAPHS_COMPONENTS = `${Home_PAGE_URL}graphs`;
export const SHARED_FOLDERS = `/${Home_PAGE_URL}sharedfolders`;
// export const CM_INGESTED_KNOWLEDGE = `${Home_PAGE_URL}ingestedKnowledge`;
export const CM_INGESTED_KNOWLEDGE = `${Home_PAGE_URL}knowledgeIngested`;
export const CM_SEARCH_SUGGESTIONS = `${Home_PAGE_URL}searchHistory`;
export const CM_SEARCH_SUGGESTION_DETAIL_PAGE = `${Home_PAGE_URL}searchsuggestionrecords`;
// export const ATOMIZER_CM = `${Home_PAGE_URL}atomizer`;
export const ATOMIZER_CM = `${Home_PAGE_URL}knowledgeAtomizer`;
// export const EXPERT_RECORDS = `${Home_PAGE_URL}expertrecords`;
export const EXPERT_RECORDS = `${Home_PAGE_URL}expertResponses`;
export const EXPERT_RECORDS_DETAILS = `${Home_PAGE_URL}expertrecordDetail/:questionUuid/:userType`;
export const MY_DOWNLOAD = `${Home_PAGE_URL}download`;
export const USER_PERMISSIONS = `${Home_PAGE_URL}permission`;
export const Manage_Role = `${Home_PAGE_URL}managerole`;
export const Restrict_permission = `${Home_PAGE_URL}restrictPermission`;
export const ADMIN_SETTINGS = `${Home_PAGE_URL}settings`;
export const AGENT_BRIEF = `${Home_PAGE_URL}brief`;
export const SAVED_BRIEF= `${Home_PAGE_URL}savebrief`;
export const NEW_EDITOR_URL=`${Home_PAGE_URL}editor/neweditor`;
export const EMAIL_TICKET_DETAILS=`${Home_PAGE_URL}emailticketdetails/:ticketId`;
// export const CURATED_VIEW=`${Home_PAGE_URL}answeredcurated`;
export const GOOGLE_ERROR_URL = `${Home_PAGE_URL}auth_error`;
export const SSO_ERROR_URL = `${Home_PAGE_URL}login_error`;
export const CURATED_VIEW=`${Home_PAGE_URL}answeredcurated`;
